import React from 'react';
import CommonModal from './Modal';
import { CraneOperatorLatestRegistrationDropdown } from '../../dropdowns/single/CraneOperatorLatestRegistration';

/**
 * @description オペレータ設定ダイアログ
 *              揚重機予定一覧画面で使用
 *              新規、編集兼用
 * @param {boolean} visible true: 表示, false, 非表示
 * @param {boolean} isEdit true: オペレータ編集の時, false, オペレータ新規の時
 * @param {object} values オペレータ設定用オブジェクト
 * @param {string} error エラーメッセージ
 * @param {function} callbacks オペレータ設定メソッド
 */
const OperatorConfig = props => {
  const { visible, isEdit, values, error, callbacks, validate } = props;

  // src/pages/CraneUses.jsxに記載
  // POST(新規登録)のAPI
  let apiFunc = callbacks.setOperator;
  if (isEdit) {
    // PATCH(編集)のAPI
    apiFunc = callbacks.setUpdateOperator;
  }

  const styles = {
    footer: {
      marginTop: 10,
      padding: 0,
    },
  };

  return (
    <React.Fragment>
      {visible && (
        <CommonModal visible={visible}>
          <div id='modal-dialog-operater' className='modal show'>
            <div className='dialog-sm dialog--modal'>
              <div className='dialog-sm__header'>
                <span className='dialog-sm__title'>オペレータを設定</span>
              </div>
              <div className='dialog-sm__body'>
                <div className='dialog-form'>
                  <CraneOperatorLatestRegistrationDropdown
                    value={values.operator_name}
                    error={error}
                    craneId={values.crane_id}
                    set={callbacks.operator}
                    validate={validate}
                  />
                  <div className='dialog-form__footer' style={styles.footer}>
                    <button
                      id='modal-close-operater'
                      className='btn--sm--sub'
                      onClick={() => callbacks.handleVisible('operator')}
                    >
                      戻る
                    </button>
                    <button
                      className={
                        !values.validate.invalid
                          ? 'btn--sm'
                          : 'btn--sm disabled'
                      }
                      // src/pages/CraneUses.jsx
                      onClick={apiFunc}
                      disabled={values.validate.invalid}
                    >
                      更新
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CommonModal>
      )}
    </React.Fragment>
  );
};

export default OperatorConfig;



// WEBPACK FOOTER //
// ./src/components/modals/common/OperatorConfig.jsx